export default __webpack_public_path__ + "e0a323a5c2dc160e3a55e395c5c942a5.mp3";